import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

export const AntSwitch = styled(Switch)(({ theme }) => ({
	'&.MuiSwitch-root': {
		width: 28,
		height: 16,
		padding: 0,
		display: 'flex',
	},
	'& .MuiSwitch-switchBase': {
		padding: 2,
		color: theme.palette.grey[500],
		'&.Mui-checked': {
			transform: 'translateX(12px)',
			color: theme.palette.common.white,
			'& + .MuiSwitch-track': {
				opacity: 1,
				backgroundColor: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
	},
	'& .MuiSwitch-thumb': {
		width: 12,
		height: 12,
		boxShadow: 'none',
	},
	'& .MuiSwitch-track': {
		border: `1px solid ${theme.palette.grey[500]}`,
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: theme.palette.common.white,
	},
}));

